import { branding } from '../app/core/config/branding';

export const environment = {
  name: 'Integration',
  production: true,
  enableTestAuth: true, // Enable test auth in integration for manual testing
  apiUrl: `https://${branding.appSlug}.int.${branding.baseDomain}/api`,
  artworkPath: 'artwork/integration',
  serviceWorkerScriptUrl: 'ngsw-worker.js?swv=20260308-1',
  showClickableQrUrls: true, // Enable clickable QR URLs for easier testing

  // Sync configuration
  syncConfig: {
    uploadIntervalMs: 5000,
    clockSyncIntervalMs: 300000, // 5 minutes
    maxReconnectAttempts: 10,
  },

  oauth: {
    google: {
      clientId: '170831075884-olg6jshvgfign7lobak7iq53rgjhmmdm.apps.googleusercontent.com',
      redirectUri: `https://${branding.appSlug}.int.${branding.baseDomain}/oauth-callback`,
    },
  },
  radar: {
    // Test publishable key -- safe to embed client-side (Radar's own docs: reverse
    // geocoding is a 'Publishable' auth-level endpoint, same security model as the
    // Google OAuth client id above). Not the live key -- switch before a real launch.
    publishableKey: 'prj_test_pk_56507e81a893574bccf37d4c2109a7beb06adf97',
  },
  here: {
    // HERE app "IxZeAtYAMInp47tVyoQH" -- safe to embed client-side, same security model as
    // the Google OAuth client id and Radar's publishable key above (HERE's REST/JS API keys
    // are meant for client-side use, restricted by HTTP referrer in the HERE console).
    apiKey: '83svbH_3t5GHY8uwOadYcggtnvrOfKLgTP3z7_grgUg',
  },
  permissions: {
    'feature.artwork-override': true, // Enabled in non-production
  },
};
